import styled from "styled-components";

export const ButtonsBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
}));

export const BaggageButton = styled("button")(({ theme }) => ({
  width: "50%",
  backgroundColor: theme.palette.fly.checkboxBg,
  border: `1px solid ${theme.palette.fly.checkboxBorder}`,
  color: theme.palette.text.primary,
  fontSize: 14,
  height: 36,
  cursor: "pointer",
  transition: "all .3s ease",

  "&:first-child": {
    borderRadius: "8px 0 0 8px",
  },

  "&:last-child": {
    borderRadius: "0 8px 8px 0",
  },

  "&.active": {
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    color: theme.palette.white,
  }
}));
